var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNomessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 256,
  height: 256,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#nomessage_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#nomessage_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#nomessage_svg__c)",
  fillOpacity: 0.6,
  d: "M130.857 88.82c-30.393 0-54.907 20.884-64.175 47.447-2.04 5.85-2.682 12.253-2.682 18.808 0 37.059 29.933 67.101 66.857 67.101h34.286a66.92 66.92 0 0 0 11.399-.992l20.189 10.066c5.019 2.502 10.797-1.603 10.113-7.186l-1.851-15.11C221.381 196.724 232 177.146 232 155.075c0-36.436-28.935-66.088-65.001-67.075l-36.142.82Z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#nomessage_svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#nomessage_svg__e)",
  fillOpacity: 0.6,
  d: "M79.898 26h30.204C142.63 26 169 52.49 169 85.169c0 3.78-.353 7.476-1.027 11.059-5.155 27.392-29.105 47.694-57.871 47.694H79.898c-3.426 0-6.777.105-10.042-.459l-17.786 8.876c-4.422 2.206-9.512-1.414-8.91-6.337l1.631-13.324C30.355 121.895 21 104.631 21 85.168 21 52.492 47.37 26 79.898 26Z"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#nomessage_svg__f)",
  strokeWidth: 7.333,
  d: "M71.062 134.784c-1.974 5.638-2.55 11.673-2.55 17.593 0 34.301 27.806 62.108 62.107 62.108h29.971c3.2 0 6.333-.255 9.388-.722l16.593 8.242c7.003 3.479 15.064-2.228 14.11-9.989l-1.363-11.086c14.243-11.375 23.38-28.896 23.38-48.553 0-33.726-26.88-61.172-60.386-62.085l-.091-.003-.091.002-31.553.713c-28.326.019-50.98 19.405-59.515 43.78Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#nomessage_svg__g)",
  d: "M130.619 94.67c-26.567 0-47.996 18.19-56.097 41.326-1.783 5.094-2.344 10.672-2.344 16.381 0 32.276 26.165 58.441 58.441 58.441h29.971c3.399 0 6.724-.306 9.964-.863l17.648 8.766c4.388 2.18 9.438-1.395 8.84-6.258l-1.618-13.161c14.325-10.651 23.608-27.703 23.608-46.925 0-31.734-25.293-57.56-56.82-58.42l-31.593.713Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#nomessage_svg__h)",
  d: "M83.646 31.445h26.885c28.954 0 52.426 23.472 52.426 52.426a52.72 52.72 0 0 1-.914 9.799c-4.589 24.271-25.907 42.259-51.512 42.259H83.645c-3.048 0-6.031.093-8.938-.406l-15.832 7.864c-3.936 1.955-8.466-1.253-7.93-5.614l1.452-11.806c-12.85-9.555-21.177-24.852-21.177-42.096 0-28.954 23.472-52.426 52.426-52.426Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#nomessage_svg__i)",
  d: "M34.094 101.502a52.558 52.558 0 0 0 18.186 24.616l-1.451 11.806c-.537 4.361 3.994 7.569 7.93 5.614l15.832-7.865c2.906.5 5.889.407 8.938.407h26.885c22.824 0 41.87-14.219 49.069-34.578H34.093Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#nomessage_svg__j)",
  strokeWidth: 7.333,
  d: "M158.44 92.989c-4.26 22.534-24.061 39.274-47.909 39.274H83.645c-.442 0-.871.001-1.29.003-2.642.009-4.856.016-7.027-.357l-1.18-.203-1.072.533-15.832 7.864 1.545 3.111-1.545-3.111c-1.32.656-2.84-.42-2.66-1.883l1.452-11.806.26-2.117-1.711-1.273c-11.96-8.892-19.699-23.118-19.699-39.153 0-26.929 21.83-48.759 48.76-48.759h26.885c26.929 0 48.759 21.83 48.759 48.76 0 3.119-.292 6.166-.85 9.117Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#nomessage_svg__k)",
  d: "M125.488 92.605c5.658 0 10.245-4.587 10.245-10.245 0-5.658-4.587-10.245-10.245-10.245-5.658 0-10.245 4.587-10.245 10.245 0 5.659 4.587 10.245 10.245 10.245Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#nomessage_svg__l)",
  d: "M96.79 92.605c5.658 0 10.245-4.587 10.245-10.245 0-5.658-4.587-10.245-10.245-10.245-5.658 0-10.245 4.587-10.245 10.245 0 5.659 4.587 10.245 10.245 10.245Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#nomessage_svg__m)",
  d: "M68.408 92.605c5.658 0 10.245-4.587 10.245-10.245 0-5.658-4.587-10.245-10.245-10.245-5.658 0-10.245 4.587-10.245 10.245 0 5.658 4.587 10.245 10.245 10.245Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#nomessage_svg__n)",
  d: "M174.04 165.469c5.658 0 10.245-4.587 10.245-10.245 0-5.658-4.587-10.245-10.245-10.245-5.658 0-10.245 4.587-10.245 10.245 0 5.658 4.587 10.245 10.245 10.245Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#nomessage_svg__o)",
  d: "M145.299 165.469c5.658 0 10.244-4.587 10.244-10.245 0-5.658-4.586-10.245-10.244-10.245-5.658 0-10.245 4.587-10.245 10.245 0 5.658 4.587 10.245 10.245 10.245Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#nomessage_svg__p)",
  d: "M116.859 165.454c5.658 0 10.245-4.587 10.245-10.245 0-5.658-4.587-10.245-10.245-10.245-5.658 0-10.245 4.587-10.245 10.245 0 5.658 4.587 10.245 10.245 10.245Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "nomessage_svg__c",
  x1: 195.928,
  x2: 159.906,
  y1: 231.57,
  y2: 120.277,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#4ECFB5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.597,
  stopColor: "#1384C1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0061A7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "nomessage_svg__e",
  x1: 51.505,
  x2: 99.198,
  y1: 26,
  y2: 142.208,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4FE3AD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.716,
  stopColor: "#4E72DF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "nomessage_svg__f",
  x1: 98.254,
  x2: 160.867,
  y1: 108.229,
  y2: 213.911,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D3EEF4",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9EF3F9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "nomessage_svg__g",
  x1: 188,
  x2: 149.174,
  y1: 219,
  y2: 104.346,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#4ECFB5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "#1384C1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0061A7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "nomessage_svg__h",
  x1: 58.373,
  x2: 100.493,
  y1: 31.445,
  y2: 134.546,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4FE3AD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.716,
  stopColor: "#4E72DF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "nomessage_svg__i",
  x1: 96.788,
  x2: 96.788,
  y1: 106.162,
  y2: 136.341,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4071F7",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#30569F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "nomessage_svg__j",
  x1: 54.612,
  x2: 110.794,
  y1: 44.251,
  y2: 139.062,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D3EEF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9EF3F9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "nomessage_svg__k",
  x1: 131.15,
  x2: 116.607,
  y1: 76.698,
  y2: 91.241,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "nomessage_svg__l",
  x1: 102.452,
  x2: 87.909,
  y1: 76.698,
  y2: 91.241,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "nomessage_svg__m",
  x1: 74.071,
  x2: 59.527,
  y1: 76.698,
  y2: 91.241,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "nomessage_svg__n",
  x1: 179.702,
  x2: 165.159,
  y1: 149.561,
  y2: 164.105,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "nomessage_svg__o",
  x1: 150.961,
  x2: 136.418,
  y1: 149.561,
  y2: 164.105,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "nomessage_svg__p",
  x1: 122.522,
  x2: 107.978,
  y1: 149.547,
  y2: 164.09,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("filter", {
  id: "nomessage_svg__b",
  width: 224,
  height: 200,
  x: 36,
  y: 60,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_16681_45075",
  stdDeviation: 14
})), /*#__PURE__*/React.createElement("filter", {
  id: "nomessage_svg__d",
  width: 204,
  height: 183,
  x: -7,
  y: -2,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_16681_45075",
  stdDeviation: 14
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "nomessage_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h256v256H0z"
})))));
export { SvgNomessage as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiOGI0NzE4ZDJiYmVlMmFhOTcxNmY5ZTEyZjAyOWZlZjYuc3ZnIjs=";